// Word.jsx
import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Typewriter } from 'react-simple-typewriter';
import Services from './Services';

const Word = () => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const [shouldType, setShouldType] = useState(false);
  const [line1Done, setLine1Done] = useState(false);
  const [showCursor1, setShowCursor1] = useState(true);

  useEffect(() => {
    if (window.innerWidth > 576 && inView) {
      setShouldType(true); // Aktifkan efek ketik hanya jika layar lebih besar dari 576px
    } else {
      setShouldType(false); // Menonaktifkan efek ketik pada layar kecil
    }
  }, [inView]);

  return (
    <section id="word" ref={ref}>
      <div ref={ref} className={`word ${inView ? 'fade-in' : ''}`}>
        {/* Bagian Typing Effect */}
        <div className="word-content">
          <h3
            style={{
              opacity: inView ? 1 : 0,
              transition: 'opacity 0.5s ease-in-out',
            }}
          >
            {shouldType ? (
              <>
                <span>
                  <Typewriter
                    words={['Jarak ke Baitullah Tidak Akan Berubah,']}
                    loop={1}
                    cursor={showCursor1}
                    cursorStyle="|"
                    typeSpeed={50}
                    deleteSpeed={0}
                    delaySpeed={1000}
                    onDelayEnd={() => {
                      setLine1Done(true);
                      setShowCursor1(false);
                    }}
                  />
                </span>
                <br />
                <span>Jika Kita Tidak Melangkah</span>
              </>
            ) : (
              <>
                {/* Tampilkan teks langsung tanpa efek ketik di layar kecil */}
                <span>Jarak ke Baitullah Tidak Akan Berubah,</span>
                <br />
                <span>Jika Kita Tidak Melangkah</span>
              </>
            )}
          </h3>
        </div>

        {/* Lanjutan konten (Services section) */}
        <div className="inside-word">
          <Services />
        </div>
      </div>
    </section>
  );
};

export default Word;
